<template>
  <Dialog
    v-model="dialog"
    color="white"
    :close="{
      left: true,
      text: 'Back',
      color: 'primary',
    }"
  >
    <template #header>Driver No Show</template>
    <template #body>
      <v-form v-model="valid">
        <v-text-field v-bind="inputProps" label="Notes" v-model="form.notes" :rules="[rules.required]" />
      </v-form>
    </template>
    <template #actions>
      <v-btn :disabled="!valid" color="primary" @click="declineAssignment">Decline Assignment</v-btn>
    </template>
  </Dialog>
</template>

<script>
import { required } from '@/util/rules';
import Dialog from '../shared/Dialog.vue';
import { inputProps } from '@/util';
import { ASSIGNMENT_STATUS } from '@/shared/common';
import { mapActions } from 'vuex';

export default {
  components: { Dialog },
  props: {
    assignmentId: { type: Number, required: true },
  },
  data() {
    return {
      dialog: true,
      inputProps,
      valid: false,
      rules: { required },
      form: {
        notes: null,
      },
    };
  },
  methods: {
    ...mapActions('assignment', ['acceptAssignment']),
    async declineAssignment() {
      await this.acceptAssignment({
        assignmentId: this.assignmentId,
        status: ASSIGNMENT_STATUS.NO_SHOW,
        notes: this.form.notes,
      });
      this.$myalert.success('Driver flagged as a no-show successfully.');
      this.$emit('refresh');
      this.$emit('close');
    },
  },
  watch: {
    dialog(value) {
      if (!value) this.$emit('close');
    },
  },
};
</script>
